import { FilterOption } from '../../../components/_WMS/FilterComponent/types'

export const filterOptions: FilterOption[] = [
  { key: 'name', label: 'Nombre Marca en WMS', type: 'text', order: 1 },
  { key: 'origin', label: 'Origen del producto', type: 'text', order: 2 },
  { key: 'isActive', label: 'Activo', type: 'yesornotoption', order: 3 }
]
